import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";
import { message } from "antd";
import { MEAL_BASE_URL } from "configs/AppConfig";

//CREATE ACTION
export const addScheduleItem = createAsyncThunk("addScheduleItem", async ({ scheduleId, menuItemId }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.post(`${MEAL_BASE_URL}mealSchedule/${scheduleId}/items`, { menuItemId });
		message.success("Menu item has been added successfully!");
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		message.error(err.response.data?.message || "Failed to add menu item");
		return rejectWithValue(err.response.data);
	}
});

const ScheduleItemAddSlice = createSlice({
	name: "ScheduleItemAddSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetScheduleItemAddState: (state) => {
			state.isLoading = false;
			state.error = false;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(addScheduleItem.pending, (state, action) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(addScheduleItem.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(addScheduleItem.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetScheduleItemAddState } = ScheduleItemAddSlice.actions;
export default ScheduleItemAddSlice.reducer;
